<template>
  <v-tooltip bottom>
    <template v-slot:activator="{ on, attrs }">
      <v-avatar
        v-bind="attrs"
        v-on="on"
        :class="`solid-border ${flagType} mx-1`"
        :size="size"
      >
        <v-icon :class="`${flagType}`">{{ icon }}</v-icon>
      </v-avatar>
    </template>
    <span v-text="tooltipMessage"></span>
  </v-tooltip>
</template>

<script>
export default {
  name: 'CargoFlagIcon',
  inheritAttrs: false,
  props: {
    flagType: {
      type: String,
      required: true,
      validator(value) {
        return ['lift', 'priority', 'heavy', 'dangerous'].indexOf(value) !== -1;
      },
    },
    size: {
      type: String,
      default: '30',
    },
  },
  computed: {
    icon() {
      switch (this.flagType) {
        case 'lift':
          return 'mdi-arrow-up-bold';
        case 'priority':
          return 'mdi-currency-usd';
        case 'heavy':
          return 'mdi-weight';
        case 'dangerous':
          return 'mdi-exclamation-thick';
        default:
          return 'mdi-arrow-up-bold';
      }
    },
    tooltipMessage() {
      switch (this.flagType) {
        case 'lift':
          return 'Lifts';
        case 'priority':
          return 'Priority';
        case 'heavy':
          return 'Heavy Goods';
        case 'dangerous':
          return 'Dangerous Goods';
        default:
          return 'Lifts';
      }
    },
  },
};
</script>

<style>
</style>
